import config from '../config';
import { request } from '../utils/request';

const cgiDomain = `${config.host}${config.apiRouter.cgi}`;

const api = {
  // ListProtocol
  get_protocol_list (data) {
    return request.post(`${cgiDomain}/ListProtocol`, data);
  },

  // AddProtocol
  add_protocol (data) {
    return request.post(`${cgiDomain}/AddProtocol`, {
      protocol: data,
    });
  },

  // GetProtocol
  get_protocol (data) {
    return request.post(`${cgiDomain}/GetProtocol`, data);
  },

  // DelProtocol
  del_protocol (data) {
    return request.post(`${cgiDomain}/DelProtocol`, data);
  },

  // UpdateProtocol
  update_protocol (data) {
    return request.post(`${cgiDomain}/UpdateProtocol`, {
      protocol: data,
    });
  },
};
export default api;
